import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { createImportJob } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import util from '@/libs/util';
import axios from 'axios';
export default {
  name: "addDocumetItem",
  mixins: [tabulation, gmToolNewPage, gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;

    var validateFile = function validateFile(rule, value, callback) {
      var isUploadMode = _this.paramsData.type === 'upload';
      var isDirectUploadMode = ['image', 'vedio'].includes(_this.paramsData.type) && _this.paramsData.UploadType === 'DirectUpload';

      if ((isUploadMode || isDirectUploadMode) && !_this.paramsData.file) {
        callback(new Error('请选择要上传的文件'));
      } else {
        callback();
      }
    };

    return {
      dialog: false,
      fileList: [],
      paramsData: {
        type: '',
        version: '',
        title: '',
        description: '',
        server_id: '',
        file: null,
        text_content: '',
        doc_type: '',
        url: '',
        UploadType: '',
        source_uri: ''
      },
      rules: {
        type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        version: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        file: [{
          required: true,
          validator: validateFile,
          trigger: "change"
        }],
        text_content: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        url: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        UploadType: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        source_uri: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {
    // 动态展示 label 标签名称
    uploadLabel: function uploadLabel() {
      if (this.paramsData.type === 'image') return '图片上传';
      if (this.paramsData.type === 'vedio') return '视频上传';
      return '文件上传';
    },
    // 动态绑定 <el-upload> 接受的扩展名
    acceptTypes: function acceptTypes() {
      if (this.paramsData.type === 'image') return '.jpg,.jpeg,.png,.gif';
      if (this.paramsData.type === 'vedio') return '.mp4,.webm';
      return '.txt,.md,.pdf,.docx,.xlsx,.csv,.json,.html';
    },
    // 动态显示上传提示文案
    uploadTipText: function uploadTipText() {
      if (this.paramsData.type === 'image') {
        return '支持扩展名:.jpg, .jpeg, .png, .gif,单文件最大 10MB';
      }

      if (this.paramsData.type === 'vedio') {
        return '支持扩展名：.mp4, .webm,单文件最大 50MB';
      }

      return '支持扩展名:.txt, .md, .pdf, .docx, .xlsx, .csv, .json, .html,单文件最大 50MB';
    }
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 17;
                  break;
                }

                _this2.paramsData.doc_type = data;

                if (!(_this2.rawData.game_mark.indexOf('yjfm') == -1)) {
                  _context.next = 7;
                  break;
                }

                console.log("this.severlist==", _this2.severlist);
                _this2.paramsData.is_prod = _this2.severlist.length ? _this2.severlist[0].value : '';
                _context.next = 16;
                break;

              case 7:
                if (!_this2.szgmEnv.length) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return _this2.szgmEnv[0].id;

              case 10:
                _context.t0 = _context.sent;
                _context.next = 14;
                break;

              case 13:
                _context.t0 = '';

              case 14:
                _this2.paramsData.env_id = _context.t0;
                _this2.paramsData.game_id = _this2.rawData.game_id;

              case 16:
                if (_this2.rawData.game_mark.indexOf('yjfm') == -1) {
                  _this2.getServer();
                }

              case 17:
                _this2.dialog = true;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getServer: function getServer() {
      var _this3 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this3.serverList = res.data;
        }
      });
    },
    handleTypeChange: function handleTypeChange() {
      this.paramsData.text_content = '';
      this.paramsData.url = '';
      this.paramsData.UploadType = '';
      this.paramsData.source_uri = '';
      this.paramsData.file = null;
      this.fileList = [];

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(['text_content', 'url', 'UploadType', 'source_uri', 'file']);
      }
    },
    handleUploadTypeChange: function handleUploadTypeChange() {
      this.paramsData.source_uri = '';
      this.paramsData.file = null;
      this.fileList = [];

      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(['source_uri', 'file']);
      }
    },
    // 文件选择与格式体积校验
    handleFileChange: function handleFileChange(file, fileList) {
      var allowedExtensions = [];
      var maxSizeMB = 50; // 默认最大 50MB

      if (this.paramsData.type === 'image') {
        allowedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        maxSizeMB = 10;
      } else if (this.paramsData.type === 'vedio') {
        allowedExtensions = ['mp4', 'webm'];
        maxSizeMB = 50;
      } else {
        allowedExtensions = ['txt', 'md', 'pdf', 'docx', 'xlsx', 'csv', 'json', 'html'];
        maxSizeMB = 50;
      }

      var fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      var isSizeValid = file.size / 1024 / 1024 < maxSizeMB;

      if (!allowedExtensions.includes(fileExtension)) {
        this.$message.error("\u4E0A\u4F20\u6587\u4EF6\u53EA\u80FD\u662F ".concat(allowedExtensions.map(function (ext) {
          return '.' + ext;
        }).join(', '), " \u683C\u5F0F!"));
        this.fileList = [];
        this.paramsData.file = null;
        return false;
      }

      if (!isSizeValid) {
        this.$message.error("\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(maxSizeMB, "MB!"));
        this.fileList = [];
        this.paramsData.file = null;
        return false;
      }

      this.fileList = fileList;
      this.paramsData.file = file.raw;
      this.$refs.ruleForm.validateField('file');
    },
    handleFileRemove: function handleFileRemove() {
      this.fileList = [];
      this.paramsData.file = null;
      this.$refs.ruleForm.validateField('file');
    },
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传单个文件，请先删除已有文件。');
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this4 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          console.log("this.paramsData===", _this4.paramsData);
          var formData = new FormData();
          formData.append('type', _this4.paramsData.type);
          formData.append('game', _this4.rawData.game_mark); // formData.append('env', this.prod.env_id ? this.prod.env_id : '');

          formData.append('version', _this4.paramsData.version);
          formData.append('title', _this4.paramsData.title);
          formData.append('doc_type', _this4.paramsData.doc_type);
          formData.append('game_id', _this4.rawData.game_id);
          formData.append('server_id', _this4.paramsData.server_id.join(","));

          if (_this4.rawData.game_mark.indexOf('yjfm') == -1) {
            formData.append('env', _this4.paramsData.is_prod);
          } else {
            var targetEnv = _this4.szgmEnv.find(function (item) {
              return item.id == _this4.paramsData.env_id;
            });

            var envFlag = targetEnv ? targetEnv.flag : '';
            formData.append('env', envFlag);
          } // formData.append('env', this.paramsData.);


          if (_this4.paramsData.type === 'text') {
            formData.append('text_content', _this4.paramsData.text_content);
          } else if (_this4.paramsData.type === 'url') {
            formData.append('url', _this4.paramsData.url);
          } else if (['image', 'vedio'].includes(_this4.paramsData.type)) {
            formData.append('text_content', _this4.paramsData.text_content || ''); // formData.append('UploadType', this.paramsData.UploadType);

            console.log("this.paramsData.UploadType", _this4.paramsData.UploadType);

            if (_this4.paramsData.UploadType == 'ExternalResources') {
              formData.append('source_uri', _this4.paramsData.source_uri);
            } else if (_this4.paramsData.UploadType == 'DirectUpload' && _this4.paramsData.file) {
              formData.append('file', _this4.paramsData.file);
            }
          } else if (_this4.paramsData.type === 'upload' && _this4.paramsData.file) {
            formData.append('file', _this4.paramsData.file);
          }

          var reqFn = "/ai-cs-config/create-import-job";
          axios.post(process.env.VUE_APP_API + reqFn, formData, {
            headers: {
              "Content-Type": 'multipart/form-data',
              "Authorization": 'Bearer ' + (util.cookies.get('token') || ''),
              "Request-Url": _this4.$route.path
            }
          }).then(function (res) {
            if (res.data.status == 'succeeded') {
              // this.$emit('change')
              _this4.$message({
                message: '操作成功',
                type: 'success'
              });

              _this4.dialog = false;
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.paramsData = {
        type: '',
        version: '',
        title: '',
        description: '',
        server_id: '',
        file: null,
        text_content: '',
        doc_type: '',
        url: '',
        UploadType: '',
        source_uri: ''
      };
      this.server_channel = '';
      this.show_test = '';
      this.fileList = [];
      this.checked = false;
      this.$refs.ruleForm.resetFields();
    }
  }
};